import React, { useState } from "react";
import StudentInfoForAdviseeList from "../../Advisor/AdviseeList/StudentInfoForAdviseeList";
import { Container, Row, Col } from "react-bootstrap";
import Spinner from "../../../../components/UI/Spinner/Spinner";
import * as actionCreators from "../../../../store/actions/BUAP/BUAP";
import { connect } from "react-redux";
import withErrorHandler from "../../../../hoc/withErrorHandler/withErrorHandler";

const ViewStudent = (props) => {
  const [load, setLoad] = useState(false);

  return (
    <React.Fragment>
      <Container>
        <Row>
          <Col>
            {load ? (
              <Spinner />
            ) : (
              <StudentInfoForAdviseeList
                studentno={props.stuno}
                usertype={props.usertype}
              ></StudentInfoForAdviseeList>
            )}
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    username: state.uname.username,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setusertype: (e) => dispatch(actionCreators.setusertype(e)),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withErrorHandler(ViewStudent));
